export const SmsSendCodeApi = 'core/smssendcode/' // 发送短信验证码
export const SmsVerifyCodeApi = 'core/smsverifycode/' // 验证短信验证码